export default __webpack_public_path__ + "static/sevdigimizisiyaparkenzorluklar-9877d91815252d5891389f98a50d5a60.jpg";